module.exports = __webpack_public_path__ + "static/media/package-01.9a4b7c5b.png";